import React from "react";
import {
  useShow,
  useGo,
} from "@refinedev/core";
import {
  Drawer,
} from "@mui/material";
import { CompanyFormSchema } from "@/utils/zod/companyFormValidation";
import { DrawerHeader } from "@/components";
import { CompanyShowContent } from "@/components/company/CompanyShowContent";

export const CompanyShow: React.FC = () => {
  const go = useGo();

  const { query } = useShow<CompanyFormSchema>({
    meta: {
      refetch: false
    }
  });
  const company = query?.data?.data;

  const onDrawerClose = () => {
    go({
      to: {
        resource: "companies",
        action: "list",
      },
      type: "replace",
    });
  };
  
  return (
    <Drawer
      open
      onClose={onDrawerClose}
      anchor="right"
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "736px",
        },
      }}
    >
      <DrawerHeader onCloseClick={onDrawerClose} />
      {company && <CompanyShowContent company={company} />}
    </Drawer>
  );
};